__turbopack_context__.v({
  "container": "styles-module-scss-module__sVspoa__container",
  "containerSpecific": "styles-module-scss-module__sVspoa__containerSpecific",
  "img": "styles-module-scss-module__sVspoa__img",
  "root": "styles-module-scss-module__sVspoa__root",
  "subtitle": "styles-module-scss-module__sVspoa__subtitle",
  "title": "styles-module-scss-module__sVspoa__title",
});
